export default "__VITE_ASSET__CAm4t1m$__"